<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon *ngIf="!displayOkButton; else dangerIcon" icon="question-mark-circle-outline"></nb-icon>
        <ng-template #dangerIcon><nb-icon icon="alert-triangle-outline"></nb-icon></ng-template>
        <div class="ml-2">{{ title }}</div>
      </div>
      <button nbButton class="ml-3" (click)="clickedNo()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div style="white-space: pre-line">{{ message }}</div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button *ngIf="!displayOkButton" nbButton status="danger" (click)="clickedNo()">
        {{ noButton }}
      </button>
      <button *ngIf="!displayOkButton" nbButton class="ml-3" status="success" (click)="clickedYes()">
        {{ yesButton }}
      </button>
      <button *ngIf="displayOkButton" nbButton status="info" (click)="clickedNo()">
        {{ okButton }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
